import { NEXT_URL_PROXY } from "../config";

export const baseReactingApiUrl = (
  url: { endPoint: string; id: string; query: string },
  reactType: string
) => {
  return `${NEXT_URL_PROXY}/${url?.endPoint}/${url?.id}/${reactType}${
    url?.query ? `?${url?.query}` : ""
  }`;
};
